import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useCreateAuthorMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (data: Parameters<typeof Api.authors.createAuthor>[1]) =>
      Api.authors.createAuthor(project, data),
  });
}
